import React from "react";
import { Select, Form } from "antd";
import { SessionStorage } from "../../../services/storage";

interface CustomerTypeDropDownProps {
  onChange?: (value: number[]) => void;
  value?: number[];
  disabled?: boolean;
  label?: string | null;
  name?: string;
  isMultipleSelect?: boolean;
  placeholder?: string;
  style?: React.CSSProperties;
  size?: 'small' | 'middle' | 'large';
}

const BusinessUnitDropDown: React.FC<CustomerTypeDropDownProps> = ({
  name,
  onChange,
  value = [],
  disabled = false,
  label = 'Customer Group',
  isMultipleSelect = true,
  placeholder = 'Select Business Unit',
  style,
  size = 'small',
}) => {
  const { businessList = [] } = JSON.parse(
    SessionStorage.get("app-storage") || "{}"
  );

  return (
    <Form.Item name={name} label={label ? label : undefined} labelCol={{ span: 24 }}>
      <Select
        style={style}
        mode={isMultipleSelect ? 'multiple' : undefined}
        allowClear
        disabled={disabled}
        placeholder={placeholder}
        onChange={onChange}
        size={size}
      // Instead of deriving `value` from IDs,
      // let AntD Form control it directly through Form.Item binding.
      >
        {businessList.map((option: { id: number; name: string }) => (
          <Select.Option key={option.id} value={option.id}>
            {option.name}
          </Select.Option>
        ))}
      </Select>
    </Form.Item>
  );
};

export default BusinessUnitDropDown;
